// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordResetView_container__1VlRn","formContainer":"PasswordResetView_formContainer__1kh6v"};